import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=14e49952&scoped=true"
import script from "./Results.vue?vue&type=script&lang=ts"
export * from "./Results.vue?vue&type=script&lang=ts"
import style0 from "./Results.vue?vue&type=style&index=0&id=14e49952&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e49952",
  null
  
)

export default component.exports